module.exports = __webpack_public_path__ + "img/yim06.db074e37.jpg";